import styled from 'styled-components';

import { theme } from '../themes/default';

export const SearchItemWrapper = styled.div`
  height: 56px;
  display: flex;
`;
export const SearchItemImageWrapper = styled.div`
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px 0;
`;
export const SearchItemInfo = styled.div`
  padding: 9px 0;
`;
export const SearchItemTitle = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.005em;
  color: ${theme.secondary};
`;
export const SearchItemMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;
export const SearchItemMetaPiece = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;

  color: ${theme.darkGrey};
`;
